<template lang="html">
  <div id="reschedulingList">
    <p>振替情報一覧</p>
    <input type="radio" id="all" v-model="display_type" value="all">
    <label for="all">すべて表示</label>
    <input type="radio" id="accepted" v-model="display_type" value="accepted">
    <label for="accepted">承認済み</label>
    <input type="radio" id="denied" v-model="display_type" value="denied">
    <label for="denied">不承認済み</label>
    <input type="radio" id="pending" v-model="display_type" value="pending">
    <label for="pending">進行中</label>
    <input type="radio" id="error" v-model="display_type" value="error">
    <label for="error">エラー</label>
    <table id="rescheduling-table">
      <thead>
          <tr>
            <th>登録日時</th>
            <th>完了日時</th>
            <th>依頼者</th>
            <th>相手</th>
            <th>振替前の情報</th>
            <th> </th>
            <th>振替後の情報</th>
            <th>状態</th>
          </tr>
      </thead>
      <tbody>
        <tr class="rescheduling-item" v-for="(rescheduling, index) in filteredReschedulings" :key="rescheduling.id"
        :class="{ itemEven: index % 2 === 0 }" v-if="rescheduling.school_id == $store.state.userInfo.school_id">
          <td>
            <p>{{ formattedDate(rescheduling.registered_datetime) }}</p>
            <p>{{ formattedTime(rescheduling.registered_datetime) }}</p>
          </td>
          <td v-if="rescheduling.updated_datetime">
            <p>{{ formattedDate(rescheduling.updated_datetime) }}</p>
            <p>{{ formattedTime(rescheduling.updated_datetime) }}</p>
          </td>
          <td v-else> ---- </td>
          <td>{{ userDisplayName(rescheduling.sender) }}</td>
          <td>{{ userDisplayName(rescheduling.receiver) }}</td>
          <td>
            <p>{{ formattedDate(rescheduling.target_reservation.date, 'YYYY-MM-DD') }}</p>
            <p>{{ formattedTime(rescheduling.target_reservation.start_time, 'HH:mm:ss')
              + '〜' + formattedTime(rescheduling.target_reservation.end_time, 'HH:mm:ss') }}</p>
            <p v-if="rescheduling.target_reservation.classroom_name">{{ rescheduling.target_reservation.classroom_name }}</p>
          </td>
          <td style="font-size: 30px;">⇨</td>
          <td v-if="rescheduling.status === 'accepted'">
            <p>{{ formattedDate(rescheduling.rescheduled_reservation.date, 'YYYY-MM-DD') }}</p>
            <p>{{ formattedTime(rescheduling.rescheduled_reservation.start_time, 'HH:mm:ss')
              + '〜' + formattedTime(rescheduling.rescheduled_reservation.end_time, 'HH:mm:ss') }}</p>
            <p v-if="rescheduling.rescheduled_reservation.classroom_name">{{ rescheduling.rescheduled_reservation.classroom_name }}</p>
          </td>
          <td v-else> ---- </td>
          <td :class="rescheduling.status">{{ reschedulingStatus(rescheduling) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'
import {
  mapActions
} from 'vuex'

export default {
  name: 'user-list',
  data () {
    return {
      reschedulings: [],
      display_type: 'all'
    }
  },
  methods: {
    ...mapActions([
      'getAllReschedulings'
    ]),
    moment: moment,
    userDisplayName (user) {
      return user.user_type === 'teacher' ? user.fullname + '先生' : user.fullname + '様'
    },
    reservationInfo (reservation) {
      return reservation.date + reservation.start_time + '〜' + reservation.end_time + reservation.classroom_name
    },
    reschedulingStatus (rescheduling) {
      if (rescheduling.status === 'accepted') {
        return '承認'
      } else if (rescheduling.status === 'denied') {
        return '不承認'
      } else if (rescheduling.status === 'pending') {
        return '進行中'
      } else if (rescheduling.status === 'error') {
        return 'エラー!'
      }
    },
    formattedDate (datetime, format = 'YYYY-MM-DD HH:mm:ss') {
      return moment(datetime, format).format('YYYY年MM月DD日')
    },
    formattedTime (datetime, format = 'YYYY-MM-DD HH:mm:ss') {
      return moment(datetime, format).format('HH時mm分')
    },
    compareReschedulings (a, b) {
      let aTime = moment(a.registered_datetime)
      let bTime = moment(b.registered_datetime)
      return aTime.isAfter(bTime) ? -1 : (aTime.isSame(bTime) ? 0 : 1)
    }
  },
  computed: {
    filteredReschedulings () {
      let sorted = this.reschedulings.sort(this.compareReschedulings)
      if (this.display_type === 'all') {
        return sorted
      } else {
        return sorted.filter((r) => {
          return r.status === this.display_type
        })
      }
    }
  },
  mounted () {
    this.getAllReschedulings()
    .then((res) => {
      this.reschedulings = res.data.reschedulings
      console.log(this.reschedulings)
    })
  }
}
</script>

<style lang="css" scoped>
#reschedulingList {
  overflow-y: scroll;
}
#rescheduling-table {
  width: 100%;
  margin: auto;
}
.rescheduling-item td {
  padding: 5px;
}
.rescheduling-item .accepted {
  background-color: lightgreen;
}
.rescheduling-item .denied {
  background-color: red;
}
.rescheduling-item .pending {
  background-color: white;
}
.rescheduling-item .error {
  background-color: rgb(0, 0, 0);
  color: rgb(255, 200, 0);
  font-weight: bold;
}
.itemEven {
  background-color: #ffffcc;
}
thead>tr>th {
  text-align: center;
}
tbody>tr:hover {
  background-color: #ffcccc
}
</style>



// WEBPACK FOOTER //
// ReschedulingList.vue?364f0e67